import { apiRequestWithChecks } from "./api";

export const account = {
  getAccountDetails(token) {
    return apiRequestWithChecks("GET", "/api/account/details", {
      Authorization: "Bearer " + token,
    });
  },
  updateAccountGeneral(token, data, logoFile) {
    const formData = new FormData();
    formData.append("CustomerAddress", data.CustomerAddress || "");
    if (logoFile) formData.append("logoFile", logoFile);
    return apiRequestWithChecks(
      "PUT",
      "/api/account/general",
      { Authorization: "Bearer " + token },
      formData
    );
  },
  getDisplaySettings(token) {
    return apiRequestWithChecks("GET", "/api/account/display-settings", {
      Authorization: "Bearer " + token,
    });
  },
  connectTwitter(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/social/twitter/connect",
      { Authorization: "Bearer " + token },
      data
    );
  },
  twitterCallback(data) {
    const query = new URLSearchParams({
      customerId: String(data.customerId || 0),
      code: data.code || "",
      state: data.state || "",
      expectedState: data.expectedState || "",
      redirectUri: data.redirectUri || "",
      codeVerifier: data.codeVerifier || "",
    }).toString();
    return apiRequestWithChecks("GET", `/auth/twitter/callback?${query}`);
  },
  getTwitterStatus(token) {
    return apiRequestWithChecks("GET", "/api/social/twitter/status", {
      Authorization: "Bearer " + token,
    });
  },
  disconnectTwitter(token, socialConnectionId) {
    const query =
      socialConnectionId > 0 ? `?socialConnectionId=${socialConnectionId}` : "";
    return apiRequestWithChecks(
      "DELETE",
      `/api/social/twitter/disconnect${query}`,
      { Authorization: "Bearer " + token }
    );
  },
  connectLinkedIn(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/social/linkedin/connect",
      { Authorization: "Bearer " + token },
      data
    );
  },
  linkedinCallback(data) {
    const query = new URLSearchParams({
      customerId: String(data.customerId || 0),
      code: data.code || "",
      state: data.state || "",
      expectedState: data.expectedState || "",
      redirectUri: data.redirectUri || "",
    }).toString();
    return apiRequestWithChecks("GET", `/auth/linkedin/callback?${query}`);
  },
  getLinkedInStatus(token) {
    return apiRequestWithChecks("GET", "/api/social/linkedin/status", {
      Authorization: "Bearer " + token,
    });
  },
  disconnectLinkedIn(token, socialConnectionId) {
    const query =
      socialConnectionId > 0 ? `?socialConnectionId=${socialConnectionId}` : "";
    return apiRequestWithChecks(
      "DELETE",
      `/api/social/linkedin/disconnect${query}`,
      { Authorization: "Bearer " + token }
    );
  },
  getLinkedInCredentialsStatus(token) {
    return apiRequestWithChecks(
      "GET",
      "/api/social/linkedin/credentials-status",
      { Authorization: "Bearer " + token }
    );
  },
  configureLinkedInCredentials(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/social/linkedin/configure",
      { Authorization: "Bearer " + token },
      data
    );
  },
  saveDisplaySettings(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/display-settings",
      { Authorization: "Bearer " + token },
      data
    );
  },
  saveDashboardAccess(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/dashboard-access",
      { Authorization: "Bearer " + token },
      data
    );
  },
  getPermissions(token) {
    return apiRequestWithChecks("GET", "/api/account/permissions", {
      Authorization: "Bearer " + token,
    });
  },
  saveSecuritySettings(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/security-settings",
      { Authorization: "Bearer " + token },
      data
    );
  },
  getLoginAccess(token) {
    return apiRequestWithChecks("GET", "/api/account/login-access", {
      Authorization: "Bearer " + token,
    });
  },
  saveLoginAccess(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/login-access",
      { Authorization: "Bearer " + token },
      data
    );
  },
  updateAccountMessaging(token, data) {
    return apiRequestWithChecks(
      "PUT",
      "/api/account/messaging",
      { Authorization: "Bearer " + token },
      data
    );
  },
  updateAccountAlertCategories(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/alert-categories",
      { Authorization: "Bearer " + token },
      data
    );
  },
  getImportSettings(token) {
    return apiRequestWithChecks("GET", "/api/account/import-settings", {
      Authorization: "Bearer " + token,
    });
  },
  saveImportSettings(token, data) {
    return apiRequestWithChecks(
      "POST",
      "/api/account/import-settings",
      { Authorization: "Bearer " + token },
      data
    );
  },
};
